module.exports = __webpack_public_path__ + "static/media/Resume-20251203.a83d2ff5.pages";